import { ChatTab } from "components/ChatTab/ChatTab";
import { openDownloadUrl } from "util/openDownloadUrl";
import { ConditionalLink } from "components/conditionalLink";
import ConditionalToolTip from "components/design/conditionalToolTip";
import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { Button } from "components/DesignSystem/Button/Button";
import {
  Combobox,
  OptionData,
} from "components/DesignSystem/Combobox/Combobox";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import Loader from "components/DesignSystem/Loader/loader";
import { Slider } from "components/DesignSystem/Slider/Slider";
import Tab from "components/DesignSystem/Tab/Tab";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";
import { Label, TextInput } from "components/DesignSystem/TextInput/TextInput";
import { FormikListener } from "components/FormikListener/FormikListener";
import { CalendarIcon } from "components/icons/CalendarIcon";
import { Cross } from "components/icons/Cross";
import { FilledTriangleWarning } from "components/icons/FilledTriangleWarning";
import { TicketUnresolved } from "components/icons/TicketUnresolved";
import { MessageBubbleUI } from "components/MessageBubble/MessageBubble";
import { PriceInput } from "components/PriceInput/PriceInput";
import { EtdUpdateHistoryCard } from "components/TaskSlider/EtdUpdateHistoryCard";
import { UnstyledChannel } from "components/UnstyledChannel/UnstyledChannel";
import { DISPLAY_DATE } from "constants/date";
import { NOTE_CREATED_SUCCESSFULLY } from "constants/ticket";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { ticketPriceSchema } from "formValidations/ticketSchema";
import { useGetMessage } from "hooks/useGetMessage";
import { useModal } from "hooks/useModal";
import { useQuery, useUpdateQuery } from "hooks/useQuery";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useToast } from "hooks/useToast";
import { MouseEvent, useEffect, useMemo, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { MultiValue, SingleValue } from "react-select";
import ClockUpdate from "static/images/ClockUpdate.svg";
import DisabledPricedTicketTag from "static/images/DisabledPricedTicketTag.svg";
import FilePdf from "static/images/FilePdf.svg";
import NonPricedTicketTag from "static/images/NonPricedTicketTag.svg";
import PricedTicketTag from "static/images/PricedTicketTag.svg";
import ThreeDots from "static/images/ThreeDots.svg";
import TicketResolvedIcon from "static/images/TicketResolved.svg";
import {
  useCreateTicketNotesMutation,
  useGetSingleChatTicketsQuery,
  useGetTicketETDHistoryQuery,
  useGetTicketNotesQuery,
  useUpdateChatTicketMutation,
} from "store/apis/chatTicket";
import { useLazyGetPreviewUrlQuery } from "store/apis/previewUrl";
import { RootState } from "store/store";
import { StreamChat } from "stream-chat";
import { useChatContext } from "stream-chat-react";
import { DefaultStreamChatGenerics } from "stream-chat-react/dist/types/types";
import {
  ChatUpdatePayload,
  TicketNotes,
  TicketPayment,
} from "types/Models/chatTicket";
import { BackendError } from "types/utils/error";
import { debounce } from "utils/debouncing";
import { formatDate, formatTime } from "utils/formatDate";
import { Preview } from "components/PreviewModal";
import { AddTicketEtd } from "./AddTicketEtd";
import { CreateChannelModal } from "./CreateChannelModal";
import { InfoItem } from "./CustomerTicket/TicketSlider";
import { ResolveTicketModal } from "./ResolveTicketModal";
import { TicketAssigneeDropdown } from "./TicketAssigneeDropdown";
import { TicketEtdModal } from "./TicketEtdModal";
import TicketTagsCombobox from "./TicketTagsCombobox";
import { TicketTypeUpdateConfirm } from "./TicketTypeUpdateConfirm";
import { TicketNotes as TicketNotesComponent } from "./TicketNotes";

const Header = ({ showChat = true }: { showChat?: boolean }) => {
  return (
    <div className="t-w-full t-px-5 t-pt-3 t-border t-border-solid t-border-b t-border-l-0 t-border-t-0 t-border-r-0 t-border-neutral-0 t-bg-surface t-flex t-flex-col t-sticky t-top-0 t-z-header">
      <Tab.List>
        <Tab.Trigger value="DETAILS">Details</Tab.Trigger>
        {showChat && <Tab.Trigger value="CHAT">Chat</Tab.Trigger>}
      </Tab.List>
    </div>
  );
};

const ChannelCreateDropDown = ({
  ticketId,
  messageId,
}: {
  ticketId: string;
  messageId?: string | null;
}) => {
  const { isOpen, close, open } = useModal();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Dropdown.Root>
        <Dropdown.Trigger asChild>
          <div>
            <Button size="xsmall" customType="ghost_icon">
              <img src={ThreeDots} alt="Action" className="t-select-none" />
            </Button>
          </div>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content sideOffset={8} side="bottom" className="t-mr-16">
            <Dropdown.Item onSelect={open}>Create chat channel</Dropdown.Item>
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
      {isOpen && (
        <CreateChannelModal
          close={close}
          isOpen={isOpen}
          ticketId={ticketId}
          messageId={messageId}
        />
      )}
    </div>
  );
};

export const TicketSlider = ({
  resolvedStatus,
  openSlider,
  setOpenSlider,
  ticketNotes,
  setTicketNotes,
  ticketNotesPage,
  setTicketNotesPage,
  chatClient,
  isInsideGroup,
  ticketIdFromProps,
}: {
  resolvedStatus: boolean;
  openSlider: boolean;
  setOpenSlider: (v: boolean) => void;
  ticketNotes: TicketNotes[];
  setTicketNotes: (v: TicketNotes[]) => void;
  ticketNotesPage: number;
  setTicketNotesPage: (v: number) => void;
  chatClient: StreamChat<DefaultStreamChatGenerics>;
  isInsideGroup: boolean;
  ticketIdFromProps?: string;
}) => {
  const { alertToast, successToast } = useToast();
  const [loadingPushPayment, setLoadingPushPayment] = useState(false);
  const [description, setDescription] = useState("");
  const [disablePushPayment, setDisablePushPayment] = useState(false);
  const [updateChatTicket, { isLoading: isResolving }] =
    useUpdateChatTicketMutation();
  const defaultTab = useSelector((store: RootState) => store.ticket.sliderTab);
  const ticketTypeUpdate = useModal();
  const queryData = useQuery();
  const { update } = useUpdateQuery();
  const ticketIdFromQueryParam =
    queryData.get("ticketUuid") || ticketIdFromProps || "";
  const { canManageInternalTickets } = useRoleBasedView();
  const etdModal = useModal();
  const addEtdModal = useModal();
  const resolveTicketModal = useModal();

  const [getPreviewUrl, { isLoading: isPreviewFetching }] =
    useLazyGetPreviewUrlQuery();
  const [previewFileId, setPreviewFileId] = useState<string | null>(null);

  const [createTicketNote, { isLoading: isNoteCreating }] =
    useCreateTicketNotesMutation();

  const { data: currentTicket, isLoading: isChatTicketLoading } =
    useGetSingleChatTicketsQuery(
      {
        ticketUuid: ticketIdFromQueryParam,
      },
      {
        skip: !ticketIdFromQueryParam,
        refetchOnMountOrArgChange: true,
      }
    );

  const { data: ticketNotesData, isSuccess } = useGetTicketNotesQuery(
    {
      groupId: currentTicket?.company_group?.uuid!,
      ticketId: currentTicket?.uuid!,
      page_num: ticketNotesPage,
    },
    {
      skip: !currentTicket?.company_group?.uuid || !currentTicket?.uuid,
    }
  );

  const { data: ticketETDHistory = [] } = useGetTicketETDHistoryQuery(
    {
      ticketId: currentTicket?.uuid!,
    },
    {
      skip:
        !currentTicket?.uuid ||
        !currentTicket?.is_internal_ticket ||
        !canManageInternalTickets,
    }
  );

  const ticketMessage = useGetMessage(currentTicket?.message_id!);
  const { notes = [], total_pages = 1 } = ticketNotesData || {};
  const isTicketPaymentCreated =
    currentTicket?.ticket_payments && currentTicket.ticket_payments.length > 0;
  const isPriceFinalized =
    isTicketPaymentCreated &&
    currentTicket.ticket_payments.some(
      (ticket_payments) => ticket_payments.is_price_finalized
    );
  const isAnyTicketPaymentPaid =
    isTicketPaymentCreated &&
    currentTicket.ticket_payments.some(
      (ticket_payments) => ticket_payments.is_ticket_paid
    );

  const today = dayjs().startOf("day");
  const etd = dayjs(currentTicket?.etd_date, "YYYY-MM-DD").startOf("day");
  const diff = etd.diff(today, "day");

  const ticketTypeTooltipText = isAnyTicketPaymentPaid
    ? "Changes are not allowed for tickets with payments already made."
    : "Changes are not allowed for tickets with pending payments.";

  const handleDisablePushPayment = () => {
    setDisablePushPayment(true);
  };

  useEffect(() => {
    if (ticketNotesPage === 1) {
      setTicketNotes([...notes]);
    } else {
      setTicketNotes([...ticketNotes, ...notes]);
    }
  }, [isSuccess]);

  /* functions */
  const closeSlider = () => {
    setOpenSlider(false);
    update({ query: "ticketUuid", value: null });
  };

  const onDownload = async (
    preview: boolean,
    document_id: string,
    e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => {
    e.stopPropagation();
    if (preview) {
      setPreviewFileId(document_id);
      return;
    }
    try {
      if (currentTicket && currentTicket.company_group?.uuid && document_id) {
        const { download_url } = await getPreviewUrl({
          groupId: currentTicket.company_group.uuid,
          fileId: document_id,
        }).unwrap();
        openDownloadUrl(download_url);
      }
    } catch (error: any) {
      alertToast({ message: error?.data?.error?.message });
    }
  };
  const groupUuid = currentTicket?.company_group?.uuid;
  const entityId = currentTicket?.entity?.uuid;

  const channelMessageUrl = `${
    currentTicket?.channel_url ||
    currentTicket?.company_group?.secondary_channel
  }/${ticketMessage?.id || ""}`;

  const chatUrl = isInsideGroup
    ? `/admin/crm/${groupUuid}/chat/${channelMessageUrl}`
    : `/chat/${channelMessageUrl}`;

  const { isForeignCA } = useRoleBasedView();

  const companyUrl = isForeignCA
    ? `/practice/crm/${groupUuid}`
    : `/admin/crm/${groupUuid}`;

  const entityUrl = isForeignCA
    ? `/practice/crm/${groupUuid}/entity/${entityId}`
    : `/admin/crm/${groupUuid}/entity/${entityId}`;

  const onFormValuesChange = debounce(
    async (formValues: Partial<ChatUpdatePayload>, isDirty: boolean) => {
      /* isDirty checks if initialValues are different from the current form values */
      try {
        if (currentTicket) {
          await updateChatTicket({
            ticket_id: currentTicket.uuid,
            ...formValues,
          }).unwrap();
        }
        setDisablePushPayment(false);
      } catch (error: any) {
        alertToast({ message: error?.data?.error?.message });
        setDisablePushPayment(false);
      }
    }
  );
  const addNotes = async (e: any) => {
    const isOnlyEnterPressed = e.keyCode === 13 && !e.shiftKey;
    try {
      if (description && isOnlyEnterPressed && currentTicket) {
        await createTicketNote({
          ticketId: currentTicket?.uuid,
          groupId: currentTicket?.company_group?.uuid!,
          description: description,
        }).unwrap();
        successToast({ message: NOTE_CREATED_SUCCESSFULLY });
        setDescription("");
        setTicketNotesPage(1);
      }
    } catch (e: any) {
      alertToast({ message: e?.data?.error?.message });
    }
  };

  const goToNextPage = () => {
    if (ticketNotesPage < total_pages) {
      setTicketNotesPage(ticketNotesPage + 1);
    }
  };

  const pushPayment = async () => {
    try {
      if (currentTicket) {
        setLoadingPushPayment(true);
        setDisablePushPayment(true);
        await updateChatTicket({
          ticket_id: currentTicket.uuid,
          is_price_finalized: true,
        }).unwrap();
        setLoadingPushPayment(false);
        setDisablePushPayment(false);
        successToast({ message: "Payment request successfully pushed" });
      }
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };
  const markTicketStatus = async (
    resolvedStatus: boolean,
    resolutionDescription?: string
  ) => {
    try {
      if (currentTicket) {
        const res = await updateChatTicket({
          ticket_id: currentTicket.uuid,
          resolved_status: resolvedStatus,
          resolution_description: resolutionDescription,
        }).unwrap();
        if (res.resolved) {
          successToast({ message: "Ticket has been marked as resolved" });
        } else {
          successToast({ message: "Ticket has been marked as unresolved" });
        }
      }
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  const startResolveFlow = () => {
    if (currentTicket?.is_internal_ticket) {
      resolveTicketModal.open();
      return;
    }
    void markTicketStatus(true);
  };

  const onConfirmResolve = async (resolutionDescription: string) => {
    await markTicketStatus(true, resolutionDescription);
    resolveTicketModal.close();
  };

  const ticket_price = currentTicket?.is_priced_ticket
    ? currentTicket.ticket_payments[0] &&
      !currentTicket.ticket_payments[0].is_price_finalized
      ? Number(currentTicket.ticket_payments[0].ticket_price)
      : 0
    : 0;

  const ticketTypeOptions = [
    {
      name: "Unpriced tickets",
      img: NonPricedTicketTag,
      value: "UNPRICED",
    },
    {
      name: "Priced tickets",
      img: isPriceFinalized ? DisabledPricedTicketTag : PricedTicketTag,
      value: "PRICED",
    },
  ].map(({ name, img, value }) => ({
    label: (
      <div className="t-flex t-items-center t-gap-2">
        <img src={img} alt="PricedTicketTag" />
        {name}
      </div>
    ),
    value,
  }));

  const defaultTicketType = ticketTypeOptions.filter(
    ({ value }) =>
      value === (currentTicket?.is_priced_ticket ? "PRICED" : "UNPRICED")
  )[0];

  const { client } = useChatContext();

  const channel = useMemo(() => {
    if (!currentTicket?.channel_url) return null;
    return client.channel("messaging", currentTicket.channel_url);
  }, [currentTicket?.channel_url]);

  return (
    <>
      <Slider open={openSlider} withOverlay type="fixed" onClose={closeSlider}>
        {isChatTicketLoading || !currentTicket ? (
          <div className="t-flex t-w-full t-h-full t-justify-center t-items-center">
            <Loader size="small" />
          </div>
        ) : (
          <>
            <div className="t-flex t-px-5 t-pt-3 t-w-full t-justify-between t-items-center">
              <div className="t-flex t-w-full t-justify-space-around t-items-center t-gap-x-1">
                <div className="t-text-subtitle-sm">{currentTicket?.name}</div>
              </div>
              <Button
                onClick={closeSlider}
                customType="ghost_icon"
                size="small"
              >
                <Cross />
              </Button>
            </div>
            <Tab.Root
              defaultValue={defaultTab || "DETAILS"}
              className="t-h-full"
            >
              <div className="t-flex t-flex-col t-h-full">
                <Header showChat={Boolean(currentTicket?.channel_url)} />
                <Tab.Content value="DETAILS" className="t-h-full">
                  <Formik
                    initialValues={{
                      ticket_title: currentTicket?.ticket_title,
                      ticket_price,
                      is_priced_ticket: currentTicket?.is_priced_ticket,
                    }}
                    validationSchema={ticketPriceSchema}
                    validateOnChange
                    onSubmit={() => {}}
                  >
                    {({ values, setFieldValue, dirty }) => (
                      <Form
                        onChange={handleDisablePushPayment}
                        className="t-m-0"
                      >
                        <FormikListener
                          values={values}
                          callback={(values) => {
                            onFormValuesChange(values, dirty);
                          }}
                        />

                        <div className="t-p-4 t-flex t-flex-col t-gap-4">
                          <Accordion.Root
                            type="multiple"
                            defaultValue={[
                              "TICKET_DETAILS",
                              "RELATED_MESSAGE",
                              "TICKET_TYPE",
                              "UPDATE",
                              "ETD_DETAILS",
                            ]}
                            className="t-flex t-gap-4 t-flex-col"
                          >
                            <Accordion.Item value="TICKET_DETAILS">
                              <Accordion.Trigger>
                                Ticket Details
                              </Accordion.Trigger>
                              <Accordion.Content>
                                <span className="t-grid t-gap-6 t-grid-cols-1 t-grid-flow-row">
                                  <span className="t-grid t-gap-6 t-grid-cols-2">
                                    <InfoItem label="Company">
                                      {isInsideGroup ? (
                                        <span className="t-text-black">
                                          {currentTicket?.company_group?.name}
                                        </span>
                                      ) : (
                                        <ConditionalLink
                                          target="_blank"
                                          to={companyUrl}
                                        >
                                          <span className="t-text-purple">
                                            {currentTicket?.company_group?.name}
                                          </span>
                                        </ConditionalLink>
                                      )}
                                    </InfoItem>
                                    {currentTicket.entity && (
                                      <InfoItem label="Entity">
                                        <ConditionalLink
                                          target="_blank"
                                          to={entityUrl}
                                        >
                                          <div className="t-flex t-items-center t-gap-1">
                                            <ReactCountryFlag
                                              countryCode={
                                                currentTicket.entity
                                                  ?.code_alpha_2
                                              }
                                              svg
                                              title={currentTicket.entity?.name}
                                              style={{
                                                width: "1.25em",
                                                height: "1.25em",
                                              }}
                                              className="t-rounded"
                                            />
                                            {currentTicket.entity?.name}
                                          </div>
                                        </ConditionalLink>
                                      </InfoItem>
                                    )}
                                  </span>

                                  <span className="t-grid t-gap-6 t-grid-cols-2">
                                    {resolvedStatus ? (
                                      <>
                                        <InfoItem label="Created by">
                                          {currentTicket?.assigned_by}
                                        </InfoItem>
                                        <InfoItem label="Created on">
                                          {dayjs(
                                            currentTicket.created_on
                                          ).format(DISPLAY_DATE)}
                                        </InfoItem>
                                        <InfoItem label="Resolved by">
                                          {currentTicket?.resolved_by}
                                        </InfoItem>
                                        <InfoItem label="Resolved on">
                                          {dayjs(
                                            currentTicket?.resolved_at
                                          ).format(DISPLAY_DATE)}
                                        </InfoItem>
                                      </>
                                    ) : (
                                      <>
                                        <InfoItem label="Created by">
                                          {currentTicket?.assigned_by}
                                        </InfoItem>
                                        <InfoItem label="Created on">
                                          {dayjs(
                                            currentTicket.created_on
                                          ).format(DISPLAY_DATE)}
                                        </InfoItem>
                                      </>
                                    )}
                                  </span>
                                  <TextInput
                                    label="Title"
                                    name="ticket_title"
                                    value={values?.ticket_title}
                                  />
                                  <InfoItem label="Tags">
                                    <TicketTagsCombobox
                                      ticketId={currentTicket?.uuid || ""}
                                      currentTags={currentTicket?.tags}
                                    />
                                  </InfoItem>
                                  <InfoItem label="Assignees">
                                    <div className="t-w-full">
                                      <TicketAssigneeDropdown
                                        currentTicketAssignees={
                                          currentTicket?.assignee || []
                                        }
                                        ticketId={currentTicket?.uuid || ""}
                                      />
                                    </div>
                                  </InfoItem>
                                  <TicketNotesComponent
                                    rowData={currentTicket}
                                    currentNoteLabel="Notes for this ticket"
                                    noteTrigger={
                                      <Button size="small">
                                        View ticket notes
                                      </Button>
                                    }
                                  />
                                </span>
                              </Accordion.Content>
                            </Accordion.Item>
                            {currentTicket?.is_internal_ticket &&
                              canManageInternalTickets && (
                                <Accordion.Item value="ETD_DETAILS">
                                  <Accordion.Trigger>
                                    Estimated time of delivery
                                  </Accordion.Trigger>
                                  <Accordion.Content>
                                    <Label>Estimated time of delivery</Label>
                                    <div className="t-flex t-gap-0.5 t-flex-col t-w-fit">
                                      {!currentTicket.etd_date ? (
                                        <Button
                                          type="button"
                                          size="small"
                                          onClick={addEtdModal.open}
                                          disabled={currentTicket.resolved}
                                        >
                                          Add ETD
                                        </Button>
                                      ) : (
                                        <Button
                                          type="button"
                                          size="small"
                                          onClick={etdModal.open}
                                          disabled={currentTicket.resolved}
                                        >
                                          <div className="t-flex t-items-center t-gap-3">
                                            <span className="t-text-body-sm t-text-text-100">
                                              {formatDate(
                                                currentTicket.etd_date
                                              )}
                                            </span>
                                            <span className="t-text-text-30 -t-mt-0.5">
                                              <CalendarIcon />
                                            </span>
                                          </div>
                                        </Button>
                                      )}
                                      {currentTicket.is_etd_overdue && (
                                        <div className="t-flex t-text-body-sm t-text-red t-gap-0.5 t-items-center">
                                          <FilledTriangleWarning />
                                          Overdue
                                        </div>
                                      )}
                                      {currentTicket.is_etd_upcoming && (
                                        <div className="t-flex t-text-body-sm t-text-yellow-80 t-gap-0.5 t-items-center">
                                          <FilledTriangleWarning />
                                          Due in {diff} days
                                        </div>
                                      )}
                                    </div>
                                    <div className="t-mt-6">
                                      <InfoItem label="History">
                                        <div className="t-flex t-flex-col t-w-full t-space-y-2 t-ml-2 t-mt-1">
                                          {ticketETDHistory?.map(
                                            (
                                              {
                                                created_by,
                                                created_at,
                                                description,
                                                reason,
                                                uuid,
                                              },
                                              index
                                            ) => (
                                              <EtdUpdateHistoryCard
                                                key={uuid}
                                                isLastStep={false}
                                                description={description}
                                                reason={reason}
                                                eventDate={created_at}
                                                profileName={created_by}
                                              />
                                            )
                                          )}
                                          <EtdUpdateHistoryCard
                                            isLastStep={true}
                                            description="Ticket was created"
                                            eventDate={currentTicket.created_on}
                                            profileName={
                                              currentTicket.assigned_by
                                            }
                                          />
                                        </div>
                                      </InfoItem>
                                    </div>
                                    {etdModal.isOpen &&
                                      currentTicket.etd_date &&
                                      currentTicket.company_group?.uuid && (
                                        <TicketEtdModal
                                          isOpen={etdModal.isOpen}
                                          close={etdModal.close}
                                          ticketId={currentTicket.uuid}
                                          currentEtd={currentTicket.etd_date}
                                          channelUrl={currentTicket.channel_url}
                                          groupId={
                                            currentTicket.company_group?.uuid
                                          }
                                          ticketName={currentTicket.name}
                                        />
                                      )}
                                    {addEtdModal.isOpen && (
                                      <AddTicketEtd
                                        {...addEtdModal}
                                        ticketId={currentTicket.uuid}
                                      />
                                    )}
                                  </Accordion.Content>
                                </Accordion.Item>
                              )}
                            <Accordion.Item value="RELATED_MESSAGE">
                              <Accordion.Trigger>
                                <div className="t-w-full t-flex t-justify-between t-items-center">
                                  Related Message
                                  {!currentTicket?.is_ticket_channel_created && (
                                    <ChannelCreateDropDown
                                      ticketId={currentTicket?.uuid || ""}
                                      messageId={currentTicket.message_id}
                                    />
                                  )}
                                </div>
                              </Accordion.Trigger>
                              <Accordion.Content>
                                <span className="t-grid t-gap-4 t-grid-cols-1 t-grid-flow-row">
                                  <InfoItem label="Channel">
                                    <ConditionalLink
                                      target="_blank"
                                      to={chatUrl}
                                    >
                                      <span className="t-text-purple">
                                        {currentTicket?.channel_name ||
                                          "General Help"}
                                      </span>
                                    </ConditionalLink>
                                  </InfoItem>
                                  {!currentTicket?.is_non_chat_ticket &&
                                    ticketMessage &&
                                    channel && (
                                      <>
                                        <div className="t-bg-i-surface-grey t-rounded t-p-1">
                                          <UnstyledChannel channel={channel}>
                                            <MessageBubbleUI
                                              hideOptions
                                              message={ticketMessage!}
                                              otherData={{
                                                sentByTheUser: false,
                                              }}
                                            />
                                          </UnstyledChannel>
                                        </div>
                                      </>
                                    )}
                                  <ConditionalLink target="_blank" to={chatUrl}>
                                    <Button
                                      customType="secondary"
                                      size="small"
                                      type="button"
                                    >
                                      Go to chat
                                    </Button>
                                  </ConditionalLink>
                                </span>
                              </Accordion.Content>
                            </Accordion.Item>
                            <Accordion.Item value="TICKET_TYPE">
                              <Accordion.Trigger>Ticket Type</Accordion.Trigger>
                              <Accordion.Content>
                                <span className="t-grid t-gap-4 t-grid-cols-1 t-grid-flow-row">
                                  <ConditionalToolTip
                                    condition={
                                      isPriceFinalized && ticketTypeTooltipText
                                    }
                                  >
                                    <span>
                                      <Combobox
                                        name="is_priced_ticket"
                                        label="Type"
                                        isMulti={false}
                                        isClearable={false}
                                        isSearchable={false}
                                        isDisabled={
                                          resolvedStatus || isPriceFinalized
                                        }
                                        menuPortalTarget={document.body}
                                        onChange={(
                                          option:
                                            | MultiValue<OptionData>
                                            | SingleValue<OptionData>
                                        ) => {
                                          if (option instanceof Array) {
                                            return null;
                                          }
                                          if (
                                            defaultTicketType.value === "PRICED"
                                          ) {
                                            ticketTypeUpdate.open();
                                            return;
                                          }
                                          setFieldValue(
                                            "is_priced_ticket",
                                            option?.value === "PRICED"
                                          );
                                        }}
                                        value={defaultTicketType}
                                        options={ticketTypeOptions}
                                      />
                                    </span>
                                  </ConditionalToolTip>
                                  {values.is_priced_ticket && (
                                    <InfoItem label="Amount">
                                      <div className="t-grid t-gap-4 t-grid-flow-col">
                                        <PriceInput
                                          name="ticket_price"
                                          type="number"
                                          placeholder="Enter amount"
                                          value={Number(values.ticket_price)}
                                          allowNegative={false}
                                          disabled={resolvedStatus}
                                          required
                                          block
                                        />
                                        <Button
                                          onClick={pushPayment}
                                          isLoading={loadingPushPayment}
                                          disabled={
                                            disablePushPayment ||
                                            values.ticket_price <= 0
                                          }
                                          block
                                        >
                                          Push payment
                                        </Button>
                                      </div>
                                    </InfoItem>
                                  )}
                                  {isTicketPaymentCreated && (
                                    <InfoItem label="Payment History">
                                      <div className="t-overflow-auto t-h-full">
                                        <div className="t-flex t-flex-col t-gap-4 t-pt-1.5 t-items-center ">
                                          {currentTicket.ticket_payments
                                            .filter(
                                              (ticket_payments) =>
                                                ticket_payments.is_price_finalized
                                            )
                                            .map(
                                              (
                                                ticketPayment: TicketPayment,
                                                index
                                              ) => {
                                                return (
                                                  <div
                                                    className="t-flex t-w-full t-justify-between t-items-center"
                                                    key={
                                                      ticketPayment
                                                        .ticket_invoice?.uuid
                                                    }
                                                  >
                                                    <div>
                                                      <div className="t-flex t-gap-2 t-w-[240px]">
                                                        <span>
                                                          {ticketPayment.is_ticket_paid ? (
                                                            <div>
                                                              <img
                                                                src={
                                                                  TicketResolvedIcon
                                                                }
                                                                alt="TicketResolvedIcon"
                                                              />
                                                            </div>
                                                          ) : (
                                                            <div className="t-text-yellow-50">
                                                              <TicketUnresolved />
                                                            </div>
                                                          )}
                                                        </span>
                                                        <div className="t-flex t-flex-col t-w-[240px]">
                                                          <span className=" t-text-neutral-70 t-text-body-sm">
                                                            {`${
                                                              currentTicket.name
                                                            } - #${
                                                              currentTicket
                                                                .ticket_payments
                                                                .length - index
                                                            }`}
                                                          </span>
                                                          <span className=" t-text-neutral-30 t-text-body-sm">
                                                            {`Payment ${
                                                              ticketPayment.is_ticket_paid
                                                                ? "completed"
                                                                : "pending"
                                                            }: $ ${
                                                              ticketPayment
                                                                .ticket_invoice
                                                                ?.amount
                                                            }`}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    {/* ticket payment pdf view */}
                                                    <div>
                                                      <Button
                                                        customType="ghost_icon"
                                                        onClick={(e) =>
                                                          onDownload(
                                                            true,
                                                            ticketPayment
                                                              .ticket_invoice
                                                              ?.document
                                                              ?.uuid || "",
                                                            e
                                                          )
                                                        }
                                                        isLoading={
                                                          isPreviewFetching
                                                        }
                                                      >
                                                        <img
                                                          src={FilePdf}
                                                          alt="PdfIcon"
                                                        />
                                                      </Button>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}
                                        </div>
                                      </div>
                                    </InfoItem>
                                  )}
                                </span>
                                <TicketTypeUpdateConfirm
                                  {...ticketTypeUpdate}
                                  updateType={() =>
                                    setFieldValue("is_priced_ticket", false)
                                  }
                                />
                              </Accordion.Content>
                            </Accordion.Item>
                          </Accordion.Root>
                        </div>
                        <div className=" t-bg-surface t-sticky t-bottom-0 t-flex t-flex-col t-gap-4 t-p-4  t-border t-border-solid  t-border-b-0 t-border-r-0 t-border-l-0 t-border-t-neutral-10">
                          {currentTicket.resolved ? (
                            <Button
                              type="button"
                              onClick={() => {
                                void markTicketStatus(false);
                              }}
                              customType="primary"
                            >
                              Mark as unresolved
                            </Button>
                          ) : (
                            <Button
                              type="button"
                              onClick={startResolveFlow}
                              customType="primary"
                            >
                              Mark as resolved
                            </Button>
                          )}
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Tab.Content>

                {Boolean(currentTicket?.channel_url) && (
                  <Tab.Content value="CHAT" className="t-h-full t-relative">
                    <ChatTab
                      key={currentTicket.channel_url}
                      channelId={currentTicket.channel_url}
                      messageId={currentTicket?.message_id || undefined}
                    />
                  </Tab.Content>
                )}
              </div>
            </Tab.Root>
          </>
        )}
      </Slider>
      <ResolveTicketModal
        isOpen={resolveTicketModal.isOpen}
        close={resolveTicketModal.close}
        onConfirm={onConfirmResolve}
        isLoading={isResolving}
      />
      <Preview
        showModal={Boolean(previewFileId)}
        closeModal={() => setPreviewFileId(null)}
        groupId={currentTicket?.company_group?.uuid}
        previewId={previewFileId}
      />
    </>
  );
};
